import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/udi-logo.png'


const _hoisted_1 = { class: "mesa-trabajo" }
const _hoisted_2 = { class: "contenedor-login" }
const _hoisted_3 = { class: "primera-mitad" }
const _hoisted_4 = { class: "button" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48",
  class: "google-icon"
}
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 2 }
const _hoisted_9 = {
  key: 0,
  class: "feedback-error"
}

import { ref } from 'vue';
import useAutenticar from '@/store/IngresoAutenticar';
import router from '@/router';


export default /*@__PURE__*/_defineComponent({
  __name: 'LoginView',
  setup(__props) {

/**
 * Pantalla de acceso.
 *
 * El único método real es el popup de Google: el backend valida un ID token de
 * Firebase en cada petición. Además, `LoginFirebaseService` restringe el acceso
 * al dominio institucional.
 *
 * ── Enrutado ─────────────────────────────────────────────────────
 *   `/Ingreso` (Ingreso) — sin permiso específico
 *
 * Vista enrutada. Obtiene sus datos a través de stores Pinia: no llama a `http`
 * ni a los servicios directamente.
 */

const store = useAutenticar()
const feedback = ref('')
const cargando = ref(false)

const ingresoGoogle = async () => {
    feedback.value = ''
    cargando.value = true
    const resultado = await store.loginGoogle()
    cargando.value = false

    if (!resultado.ok) {
        feedback.value = resultado.error ?? 'Error al ingresar'
    } else {
        router.push({ name: 'Dashboard' })
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"marca-sipaes\" data-v-df74369c><span class=\"marca-nombre\" data-v-df74369c>SIPAES</span><span class=\"marca-version\" data-v-df74369c><span class=\"marca-guion\" data-v-df74369c></span><span class=\"marca-version-texto\" data-v-df74369c>Versión 2.0</span><span class=\"marca-guion\" data-v-df74369c></span></span></div><h1 data-v-df74369c>Ingresar</h1><p class=\"subtitulo\" data-v-df74369c>Usa tu cuenta institucional <strong data-v-df74369c>@udi.edu.co</strong></p>", 3)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            class: "btn google",
            onClick: _withModifiers(ingresoGoogle, ["prevent"]),
            disabled: cargando.value
          }, [
            (!cargando.value)
              ? (_openBlock(), _createElementBlock("svg", _hoisted_6, _cache[0] || (_cache[0] = [
                  _createStaticVNode("<path fill=\"#EA4335\" d=\"M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z\" data-v-df74369c></path><path fill=\"#4285F4\" d=\"M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z\" data-v-df74369c></path><path fill=\"#FBBC05\" d=\"M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z\" data-v-df74369c></path><path fill=\"#34A853\" d=\"M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z\" data-v-df74369c></path><path fill=\"none\" d=\"M0 0h48v48H0z\" data-v-df74369c></path>", 5)
                ])))
              : _createCommentVNode("", true),
            (cargando.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, "Ingresando..."))
              : (_openBlock(), _createElementBlock("span", _hoisted_8, "Ingresar con Google"))
          ], 8, _hoisted_5)
        ]),
        (feedback.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(feedback.value), 1))
          : _createCommentVNode("", true)
      ]),
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "segunda-mitad" }, [
        _createElementVNode("img", {
          src: _imports_0,
          alt: "imagen centrada",
          class: "imagen-centrada"
        })
      ], -1))
    ])
  ]))
}
}

})